// imports react
import { useState } from "react";

// imports components
import fundoImage from "../images/fundoEvokTM.jpg";
import styles from "../styles/login.module.css";

export function LoginDivEVOK() {
  return (
    <div
      className={`d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2 ${styles.divImageEvok}`}
      style={{
        backgroundImage: `url(${fundoImage})`,
      }}
    >
      <div className="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">

        {/*  15/08/24 - IMAGEM DE FUNDO JÁ COM TEXTO

        <a href="index.html" className="mb-0 mb-lg-12">
          <img
            alt="Logo EVOK"
            src="./logoEVOK.png"
            className="h-60px h-lg-75px"
          />
        </a>

        <h1 className="d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7">
          Transforme potencial em excelência com EVOK™
        </h1>

        <div className="d-none d-lg-block text-white fs-base text-center">
          Impulsione resultados de alto impacto com insights profundos e
          análises personalizadas
        </div>
      */}
      </div>
    </div>
  );
}
